import { __awaiter, __generator } from "tslib";
import { NetworkService } from '../Services/NetworkService';
var ComplaintRepo = /** @class */ (function () {
    function ComplaintRepo() {
    }
    Object.defineProperty(ComplaintRepo, "getComplaintList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, filter) {
            return __awaiter(this, void 0, void 0, function () {
                var complaintList;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, "customer-complaint/partial?searchKey=" + filter.searchKey + "&pageSize=" + filter.pageSize + "&currentPage=" + filter.currentPage, 'GET')];
                        case 1:
                            complaintList = _a.sent();
                            return [2 /*return*/, complaintList];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintRepo, "getComplaintDetail", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, id) {
            return __awaiter(this, void 0, void 0, function () {
                var complaintDetail;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, "customer-complaint/" + id, 'GET')];
                        case 1:
                            complaintDetail = _a.sent();
                            return [2 /*return*/, complaintDetail];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintRepo, "createComplaint", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, body) {
            return __awaiter(this, void 0, void 0, function () {
                var created;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'customer-complaint', 'POST', body, { shouldShowMessage: true })];
                        case 1:
                            created = _a.sent();
                            return [2 /*return*/, created];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintRepo, "updateComplaint", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, id, body) {
            return __awaiter(this, void 0, void 0, function () {
                var updated;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, "customer-complaint/" + id, 'PUT', body)];
                        case 1:
                            updated = _a.sent();
                            return [2 /*return*/, updated];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintRepo, "getComplaintTimeline", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, id) {
            return __awaiter(this, void 0, void 0, function () {
                var timeline;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, "get-timeline-data/" + id, 'GET')];
                        case 1:
                            timeline = _a.sent();
                            return [2 /*return*/, timeline];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintRepo, "uploadComplaintFile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, data) {
            return __awaiter(this, void 0, void 0, function () {
                var uploadFile;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'upload', 'POST', data, { isUpload: true })];
                        case 1:
                            uploadFile = _a.sent();
                            return [2 /*return*/, uploadFile];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintRepo, "approveComplaint", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, id, body) {
            return __awaiter(this, void 0, void 0, function () {
                var approved;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, "customer-complaint/approve/" + id, 'PUT', body, { shouldShowMessage: true })];
                        case 1:
                            approved = _a.sent();
                            return [2 /*return*/, approved];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintRepo, "rejectComplaint", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, id, body) {
            return __awaiter(this, void 0, void 0, function () {
                var rejected;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, "customer-complaint/reject/" + id, 'PUT', body, { shouldShowMessage: true })];
                        case 1:
                            rejected = _a.sent();
                            return [2 /*return*/, rejected];
                    }
                });
            });
        }
    });
    return ComplaintRepo;
}());
export { ComplaintRepo };
//# sourceMappingURL=data:application/json;base64,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